import script from "./terminal-usage-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./terminal-usage-list.vue?vue&type=script&setup=true&lang=ts"

import "./terminal-usage-list.vue?vue&type=style&index=0&id=7a9e9afb&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a9e9afb"]])

export default __exports__